// Module
var code = "<template id=\"block-3__image-template\"> <div class=\"block-3__image image\"></div> </template> ";
// Exports
export default code;